/**
 * Меню аккаунта в мастхеде: один пункт на каждую назначенную роль (задача 22).
 *
 * Набор ролей приходит с сервера при входе (`PublicUser.roles`), порядок — по старшинству,
 * поэтому пункты идут сверху вниз от старшей роли: «Организатор», «Администрирование»,
 * «Заявка». «Выйти» — всегда последним и красным. Пункты строятся данными
 * (`MastheadUser`), поэтому добавление роли — правка `roles.json` и подписей в
 * `src/shared/roles.ts`, а не разметки мастхеда.
 */
import { ROLE_TITLES, roleLabel, visibleRoles } from '../shared/roles';
import type { PublicUser } from '../shared/types';
import type { MastheadMenuItem, MastheadUser } from './dom';
import { LOGIN_HREF, navigate, roleScreenHref } from './router';
import { clearSession } from './session';

/** Мастхед вошедшего пользователя: имя, подпись ролей и меню экранов. */
export function userMasthead(user: PublicUser): MastheadUser {
  return {
    name: `${user.firstName} ${user.lastName}`,
    roleLabel: roleLabel(user.roles),
    homeHref: roleScreenHref(visibleRoles(user.roles)[0]),
    items: [...screenItems(user), logoutItem()],
  };
}

/** Пункты экранов: по одному на роль, в порядке старшинства ролей пользователя. */
function screenItems(user: PublicUser): MastheadMenuItem[] {
  return visibleRoles(user.roles).map((role) => ({
    label: ROLE_TITLES[role],
    onClick: () => navigate(roleScreenHref(role)),
  }));
}

/** Пункт «Выйти»: сессия удаляется целиком, далее экран входа. */
function logoutItem(): MastheadMenuItem {
  return {
    label: 'Выйти',
    danger: true,
    onClick: () => {
      // navigate, а не присваивание хеша: адрес мог уже быть #/login, и тогда смены
      // хеша не произошло бы — экран остался бы прежним.
      clearSession();
      navigate(LOGIN_HREF);
    },
  };
}
